import React from "react";

const LocationOverview = ({
  width = 40,
  height = 40,
}: {
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="40" height="40" rx="4" fill="#F6F8FA" />
      <path
        d="M20 26.6749L23.7125 22.9624C24.4467 22.2282 24.9466 21.2927 25.1492 20.2743C25.3517 19.256 25.2477 18.2004 24.8503 17.2411C24.4529 16.2818 23.78 15.4619 22.9167 14.8851C22.0533 14.3082 21.0383 14.0003 20 14.0003C18.9617 14.0003 17.9467 14.3082 17.0833 14.8851C16.22 15.4619 15.5471 16.2818 15.1497 17.2411C14.7523 18.2004 14.6483 19.256 14.8508 20.2743C15.0534 21.2927 15.5533 22.2282 16.2875 22.9624L20 26.6749ZM20 28.7959L15.227 24.0229C14.283 23.0789 13.6401 21.8762 13.3797 20.5668C13.1193 19.2575 13.2529 17.9003 13.7638 16.6669C14.2747 15.4335 15.1399 14.3793 16.2499 13.6376C17.3599 12.8959 18.665 12.5 20 12.5C21.335 12.5 22.6401 12.8959 23.7501 13.6376C24.8601 14.3793 25.7253 15.4335 26.2362 16.6669C26.7471 17.9003 26.8808 19.2575 26.6203 20.5668C26.3599 21.8762 25.717 23.0789 24.773 24.0229L20 28.7959ZM20 20.7499C20.3978 20.7499 20.7794 20.5919 21.0607 20.3106C21.342 20.0293 21.5 19.6478 21.5 19.2499C21.5 18.8521 21.342 18.4706 21.0607 18.1893C20.7794 17.908 20.3978 17.7499 20 17.7499C19.6022 17.7499 19.2206 17.908 18.9393 18.1893C18.658 18.4706 18.5 18.8521 18.5 19.2499C18.5 19.6478 18.658 20.0293 18.9393 20.3106C19.2206 20.5919 19.6022 20.7499 20 20.7499ZM20 22.2499C19.2044 22.2499 18.4413 21.9339 17.8787 21.3713C17.3161 20.8087 17 20.0456 17 19.2499C17 18.4543 17.3161 17.6912 17.8787 17.1286C18.4413 16.566 19.2044 16.2499 20 16.2499C20.7957 16.2499 21.5587 16.566 22.1213 17.1286C22.6839 17.6912 23 18.4543 23 19.2499C23 20.0456 22.6839 20.8087 22.1213 21.3713C21.5587 21.9339 20.7957 22.2499 20 22.2499Z"
        fill="#868C98"
      />
    </svg>
  );
};

export default LocationOverview;
